import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// Pages
import HomePage from "./pages/HomePage";
import CTISLayout from "./channels/ctis/CTISLayout";
import CTISHomePage from "./channels/ctis/pages/CTISHomePage";
import CTISItemRegisterPage from "./channels/ctis/pages/CTISItemRegisterPage";
import CTISRulesPage from "./channels/ctis/pages/CTISRulesPage";
import CTISFieldLimitsPage from "./channels/ctis/pages/CTISFieldLimitsPage";
import CTISMemberStateOverlaysPage from "./channels/ctis/pages/CTISMemberStateOverlaysPage";
import CTISPackageBuilderPage from "./channels/ctis/pages/CTISPackageBuilderPage";
import CTISValidationPage from "./channels/ctis/pages/CTISValidationPage";
import { CTISSchemaProvider } from "./channels/ctis/pages/CTISSchemaProvider";
import CTISTemplateRendererPage from "./channels/ctis/pages/CTISTemplateRendererPage";

const GlobalHeader = () => (
  <header className="text-center py-4 bg-light border-bottom">
    <div className="container" style={{ maxWidth: "1320px" }}>
      <h1 className="display-5 fw-bold text-dark mb-2">Proof of Concept</h1>
      <h2 className="h4 text-secondary mb-3">Regulatory Submission Workbench</h2>
      <p className="lead mx-auto px-3 mb-0" style={{ maxWidth: "800px" }}>
        This application is a proof of concept for submissions and submission-package
        modelling across CTIS, MDR / IVDR, and Precision Medicine workflows.
      </p>
    </div>
  </header>
);

const GlobalFooter = () => (
  <footer className="text-center py-3 border-top text-muted small bg-white">
    <div className="container" style={{ maxWidth: "1320px" }}>
      &copy; {new Date().getFullYear()} welshmanofsteel. All rights reserved.
    </div>
  </footer>
);

const StandardPageShell = ({ children }) => (
  <>
    <GlobalHeader />
    {children}
    <GlobalFooter />
  </>
);

export const RouteDefinitions = [
  {
    path: "/",
    element: (
      <StandardPageShell>
        <HomePage />
      </StandardPageShell>
    ),
    handle: { crumb: "Home" }
  },
  {
    path: "/ctis",
    element: (
      <CTISSchemaProvider>
        <StandardPageShell>
          <CTISLayout />
        </StandardPageShell>
      </CTISSchemaProvider>
    ),
    handle: { crumb: "CTIS" },
    children: [
      {
        index: true,
        element: <CTISHomePage />
      },
      {
        path: "item-register",
        element: <CTISItemRegisterPage />,
        handle: { crumb: "Item Register" }
      },
      {
        path: "rules",
        element: <CTISRulesPage />,
        handle: { crumb: "Rules Checklist" }
      },
      {
        path: "field-limits",
        element: <CTISFieldLimitsPage />,
        handle: { crumb: "Field Limits" }
      },
      {
        path: "templates/:templateId",
        element: <CTISTemplateRendererPage />,
        handle: { crumb: "Template View" }
      },
      {
        path: "member-state-overlays",
        element: <CTISMemberStateOverlaysPage />,
        handle: { crumb: "Member State Overlays" }
      },
      {
        path: "package-builder",
        element: <CTISPackageBuilderPage />,
        handle: { crumb: "Package Builder" }
      },
      {
        path: "validation",
        element: <CTISValidationPage />,
        handle: { crumb: "Validation" }
      }
    ]
  },
  {
    path: "/mdr-ivdr",
    element: (
      <StandardPageShell>
        <div className="py-4 text-center">
          <h1>MDR / IVDR Placeholder</h1>
        </div>
      </StandardPageShell>
    ),
    handle: { crumb: "MDR / IVDR" }
  },
  {
    path: "/precision-medicine",
    element: (
      <StandardPageShell>
        <div className="py-4 text-center">
          <h1>Precision Medicine Placeholder</h1>
        </div>
      </StandardPageShell>
    ),
    handle: { crumb: "Precision Medicine" }
  }
];

const router = createBrowserRouter(RouteDefinitions);

export default function AppRoutes() {
  return <RouterProvider router={router} />;
}